import { createContext, useContext } from 'react';
import { type Theme } from '../../types/Theme';
import { defaultTheme } from './constants';

export const ThemeContext = createContext<Theme>(defaultTheme);
export const useTheme = () => useContext(ThemeContext);
